import { render, staticRenderFns } from "./SystemMenuEdit.vue?vue&type=template&id=9585d4d4&scoped=true"
import script from "./SystemMenuEdit.vue?vue&type=script&lang=js"
export * from "./SystemMenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585d4d4",
  null
  
)

export default component.exports